module.exports = __webpack_public_path__ + "static/img/sol.3ae05ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/sol.png
// module id = 5s95
// module chunks = 31